import { useTranslation } from "react-i18next";
import { faTrashAlt } from "@fortawesome/pro-regular-svg-icons/faTrashAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MprcButton } from "components";
import { DeletePublicationFactory } from "./DeletePublicationFactory";
import { useCardContext } from "../../CardBuilder";
import { useCallback, useState } from "react";

export const DeleteButton = () => {

    const { pub: { title, publicationId, isDraft, masterPublication, publicationType }, onFeedItemChanged } = useCardContext();
    const [dialog, setDialog] = useState<any>();

    const { t } = useTranslation("knowledge");

    const doDelete = useCallback(() => {
        setDialog(<DeletePublicationFactory
            publicationId={publicationId}
            title={title}
            isDraft={isDraft}
            publicationType={publicationType}
            isThread={masterPublication != null}
            onClose={
                (deleted) => {
                    if (deleted) onFeedItemChanged({ deletedOn: new Date() });
                    setDialog(null);
                }
            }
        />);
    }, []);

    return (
        <>
            {dialog}
            <MprcButton startIcon={<FontAwesomeIcon icon={faTrashAlt} fixedWidth />} color="error" onClick={doDelete}>
                {t("Feed.Card.Common.DeleteButtonText")}
            </MprcButton>
        </>
    );
}
